import styled from 'styled-components';

export const Content = styled.div`
  table td {
    max-width: 150px;
  }

  .form-input {
    margin-bottom: 20px;
  }

  .assignedTo {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: var(--color-text-muted);
    padding: 20px 0 10px;
  }

  .assignee-comment {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: var(--color-text-muted);
    padding: 20px 0 10px;
  }

  .textarea-wrapper {
    display: flex;
    width: 100%;
  }

  .text {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: var(--color-text-muted);
  }

  .radioWrapper {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: var(--color-text);
    height: 24px;
  }

  .customTable {
    height: 250px;
    overflow-y: auto;
    overflow-x: hidden;

    tr {
      cursor: pointer;
    }

    thead tr {
      cursor: default;

      td,
      th {
        height: auto;
        padding: 10px 0;
      }
    }

    tbody td {
      padding: 10px 0;
    }
  }

  .buttonGroup {
    display: flex;
    gap: 10px;
    justify-content: flex-start;
    margin-top: 20px;

    button {
      width: 130px;
    }
  }

  .assignTo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 20px;
    color: var(--color-text-muted);

    svg {
      cursor: pointer;
    }

    .assignToText {
      font-weight: 400;
      font-size: 16px;
      line-height: 150%;
      color: var(--color-text);
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
